<template>
  <div id="WithdrawalAccount" class="sun">
    <ValidationObserver v-slot="{ invalid }" ref="withdrawalvalidform" slim>
      <p class="title">비상금 지급 및 매출 반환 계좌:</p>
      <div class="account">
        <FormInput
          :key="$store.getters['filter/getBanksKey']"
          :disabled="!isUpdatable || !isWithdrawAccountUpdatable || isLoading"
          name="bank"
          rules="required|numeric"
          class="has-bank"
          type="text"
          v-bank-name
          @click="showBanks"
          placeholder="은행 선택"
          v-model="withdrawBankCode"
        />
        <FormInput
          name="accountno"
          class="has-account-no"
          type="tel"
          @input="inputAccountNo('withdrawal')"
          :disabled="!isUpdatable || !isWithdrawAccountUpdatable || isLoading"
          v-model="withdrawal.account_number"
          rules="required|numeric"
          placeholder="계좌번호 입력"
        />
      </div>
      <button
        :disabled="invalid || !isUpdatable || !isWithdrawAccountUpdatable || isLoading"
        class="section-btn"
        type="button"
        @click="putWithdrawalAccount"
      >
        인증하기
        <v-progress-circular
          style="padding-left: 15px;"
          size="16"
          v-if="isLoading"
          indeterminate
          color="primary"
        />
      </button>
    </ValidationObserver>
    <div class="guide">
      <div class="guide-item">
        <div class="description">
          비상금 지급 및 카드 매출 금액이 입금되는 계좌입니다.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Apis
import userApi from '@/api/now/userApi'

// Services
import UserService from '@/service/user/UserService'

// Components
import FormInput from '@/components/form/FormInput'

export default {
  name: 'WithdrawalAccount',
  components: {
    FormInput
  },
  props: ['withdrawal', 'withdrawBankCode', 'isUpdatable', 'user'],
  watch: {
    withdrawBankCode(value) {
      this.withdrawal.bank = value
      this.$forceUpdate()
    }
  },
  data() {
    return {
      isWithdrawAccountUpdatable: false,
      isLoading: false,
    }
  },
  async created() {
    this.getIsWithdrawAccountUpdatable()
    await this.getDocument()
  },
  methods: {
    inputAccountNo(type) {
      let number = this[type].account_number
      if (number != null && number.length > 0) {
        this[type].account_number = number.replace(/[^\d]/g, '')
      }
    },
    getIsWithdrawAccountUpdatable() {
      return new Promise(async (resolve, reject) => {
        try {
          let { data } = await userApi.getWithdrawalAccounts()
          this.isWithdrawAccountUpdatable = !data || window.isEmpty(data.account_number)
          resolve(this.isWithdrawAccountUpdatable)
        } catch (e) {
          console.error(e, 'getWithdrawalAccounts')
          reject(e)
        }
      })
    },
    async putWithdrawalAccount() {
      if (this.isLoading === true) {
        return
      }
      this.isLoading = true

      if (await this.getIsWithdrawAccountUpdatable() === false) {
        alert('출금계좌가 이미 등록되어 있습니다.')
        this.$router.push({ name: 'dashboard' })
        return
      }

      let obj = Object.assign({}, this.withdrawal)
      delete obj.isLoading

      try {
        obj.holder_name = await this.checkAccountOwnerName(obj)
      } catch (e) {
        this.isLoading = false
        return
      }

      try {
        await UserService.putUserWithdrawalAccount(obj)
        await this.$router.push({ name: 'kyc/verify-withdrawal-account' })
      } catch (e) {
        alert('출금 계좌 저장에 실패했습니다.')
        console.error(e, 'putUserWithdrawalAccount')
      } finally {
        this.isLoading = false
      }
    },
    checkAccountOwnerName(obj, type) {
      return new Promise(async (resolve, reject) => {
        try {
          let { data: ownerName } = await userApi.getAccountOwner(obj)
          if (window.isEmpty(ownerName) || ownerName.indexOf(this.user.name) === -1) {
            alert('계좌 정보가 불일치 합니다.\n다시 확인 후 입력해주세요.')
            reject(new Error())
          } else {
            alert(`예금주 : ${ownerName}\n해당 계좌를 ${type === 'withdrawal' ? '출금계좌로 ' : ''}등록합니다.`)
            resolve(ownerName)
          }
        } catch (e) {
          console.error(e, 'getAccountOwner')
          reject(e)
        }
      })
    },
    showBanks() {
      if (this.isUpdatable) {
        this.$emit('show-banks')
      }
    },
  },
  computed: {
    stepFirst() {
      return !this.withdrawal.account_number
    },
  },
}
</script>

<style lang="scss" scoped>
$default-blue-color: #1baaf1;
$btn-disable-background-color: #e3ecf6;
$gray-text-color: #727d8c;

#WithdrawalAccount {
  width: 100%;
  font-size: 16px;
  padding-top: 12px;
  padding-bottom: 12px;

  .title {
    font-weight: 900;
    margin-bottom: 15px;
  }

  .section-btn {
    font-size: 18px;
    background-color: $default-blue-color;
    color: #ffffff;
    &:disabled {
      color: $gray-text-color;
      background-color: $btn-disable-background-color;
    }
  }
  .account {
    display: flex;
    border-radius: 4px;
    margin-bottom: 10px;

    input.has-account-no {
      flex: 2 2 65%;
      text-align: center;
      padding: 0;
      &::placeholder {
        color: #8a94a2;
        font-weight: normal;
      }
    }
    .has-bank:hover:enabled {
      color: #ffffff !important;
      background-color: #048cff;
    }
    .has-bank {
      cursor: pointer;
      text-align: center;
      color: #333333 !important;
      font-weight: 700;
      padding: 0;
      font-size: 16px;
      background-color: #ffffff;
      flex: 1 1 35%;
      border-radius: 4px;
      color: #8a94a2;
      border: 1px solid #d7e1ea;
      &::placeholder {
        color: #8a94a2;
        font-weight: normal;
      }
    }
    .has-bank:disabled {
      background-color: #ffffff !important;
      cursor: default;
    }
    :not(:last-child) {
      margin-right: 10px;
    }
  }

  .guide {
    margin-top: 8px;

    .guide-item {
      .description {
        font-weight: normal;
        font-size: 14px;
        color: $gray-text-color;
        line-height: 1.43;
      }

      .download {
        width: 100%;
        font-size: 12px;
        color: $gray-text-color;
        line-height: 27px;
        margin-top: 8px;
        a {
          float: right;
          display: inline-block;
          padding: 6px 12px;
          font-size: 12px;
          line-height: 15px;
          border-radius: 15px;
          color: #727d8c;
          background-color: white;
          text-decoration: none;
          border: solid 1px #d7e1ea;
          margin-left: 4px;
        }
      }
    }
  }

  .section-btn {
    width: 100%;
    border-radius: 4px;
    font-weight: 700;
    text-align: center;
    padding-top: 13px;
    padding-bottom: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
  }
}
</style>
